<section class="submission-page">
  <div class="submission-shell">
    <div class="submission-icon" aria-hidden="true">
      <span>✓</span>
    </div>

    <h1>{{ title }}</h1>
    <p class="lead">
      Your <strong>{{ stakeholderType }}</strong> request has been successfully sent to the MSLDC Admin for review and approval.
    </p>
    <p class="subtext">
      You will be notified on your registered email once the admin processes your application.
    </p>

    <div class="details-card">
      <div class="details-head">Submission Details</div>
      <dl>
        <div>
          <dt>Reference No.</dt>
          <dd>{{ registrationNo }}</dd>
        </div>
        <div>
          <dt>Stakeholder Type</dt>
          <dd>{{ stakeholderType }}</dd>
        </div>
        <div>
          <dt>Submitted On</dt>
          <dd>{{ submittedOn }}</dd>
        </div>
        <div>
          <dt>Status</dt>
          <dd><span class="status-pill">{{ status }}</span></dd>
        </div>
      </dl>
    </div>

    <div class="info-box">
      <span class="info-icon">i</span>
      <p>Admin review typically takes 2-3 working days. For urgent queries contact MSLDC helpdesk at <strong>helpdesk-rdsm@msldc.gov.in</strong>.</p>
    </div>

    <div class="actions">
      <a routerLink="/register" class="btn ghost">Register Another</a>
      <a routerLink="/login" class="btn primary">Back to Login</a>
    </div>
  </div>
</section>
